import { aiearthReducer, airReducer, databaseReducer, globalFlagsReducer, jobReducer, mapReducer, quickPromptsReducer, savedChatReducer, searchReducer } from './aiearth/reducer';
import { applyMiddleware, combineReducers, createStore } from 'redux';

import thunkMiddleware from 'redux-thunk';
import { jurisdictionReducer } from './jurisdiction/reducer';

const rootReducer = combineReducers({
  aiearth: aiearthReducer,
  job: jobReducer,
  map: mapReducer,
  database: databaseReducer,
  air: airReducer,
  search: searchReducer,
  savedChat: savedChatReducer,
  globalFlags: globalFlagsReducer,
  quickPrompts: quickPromptsReducer,
  jurisdiction: jurisdictionReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default function configureStore() {
  const middlewares = [thunkMiddleware];
  const middleWareEnhancer = applyMiddleware(...middlewares);
  const store = createStore(rootReducer, middleWareEnhancer);
  return store;
}
